import { Injectable } from '@angular/core';
import { LOCAL_STORAGE } from '../local-storage.mock';

@Injectable()
export class LocalStorageServiceMock {
  get(key: any) {
    const data = LOCAL_STORAGE[key];
    return JSON.stringify(data);
  }

  getTablePageSize() {
    return {};
  }
}
